<template>
  <div class="surveys-tab">
    <SubpanelTable
      v-if="tableTitle && tableList && tableList.length"
      :tableColumns="tableTitle"
      :tableData="tableList"
      @rowClick="openQuestionnaires"
      subpanelName="surveys"
      style="min-height: 200px"
    ></SubpanelTable>
    <div v-else>
      <Alert text="Опросы ещё не были назначены" />
    </div>
  </div>
</template>
<script>
import { mixin } from '@/utils/mixins';
import Alert from 'Elements/Alert/Alert';
import SubpanelTable from 'Elements/Table/SubpanelTable';

export default {
  mixins: [mixin],
  props: {
    metadata: [Array, Object]
  },
  data() {
    return {
      tableTitle: [],
      tableList: []
    };
  },
  created() {
    if (this.metadata.data && this.metadata.data.title) {
      this.tableTitle = {
        ...this.metadata.data.title,
        survey_actions: {
          lbl: {
            name: 'LBL_TYPE_ITEMS_ALT',
            type: 'string',
            value: ''
          },
          type: 'varchar',
          width: 50,
          key_in_dataset: 'actions'
        }
      };
    }
    if (this.metadata.data && this.metadata.data.List) {
      this.tableList = this.metadata.data.List;
    }
  },
  methods: {
    openQuestionnaires() {
      return;
    }
  },
  computed: {
    backUrl() {
      return this.$store.state.navbar.navigationData.primary_button_area
        .find(item => item.name === 'BOARD_VERIFICATION_STAGES')
        .intents[0].request.url.split('index')[0];
    }
  },
  components: {
    SubpanelTable,
    Alert
  }
};
</script>

<style lang="scss" scoped>
.surveys-tab {
  padding: 24px;
  background: $white;
  border-radius: 4px;
}
</style>
